import React, { useCallback } from "react";
import { useState, useEffect } from "react";
import moment from "moment";
import ProgressBar from "../ProgressBar/ProgressBar";
import "./Timer.scss";

const Timer = ({ date_from, height = 25 }) => {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(null);

  // const [color, setColor] = useState("success");
  const progressTime = moment().diff(moment(date_from), "milliseconds");

  // const deadline = "November, 20, 2023";

  const getTime = () => {
    // const time1 = Date.now() - Date.parse(deadline);
    const time = moment().diff(moment(date_from), "milliseconds");

    // if (time > 15 * 60 * 1000) {
    //   setColor("error");
    // }

    setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
    setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
    setMinutes(Math.floor((time / 1000 / 60) % 60));
    setSeconds(Math.floor((time / 1000) % 60));
  };

  useEffect(() => {
    const interval = setInterval(() => getTime(), 1000);
    return () => clearInterval(interval);
  }, []);

  const getText = useCallback(() => {
    return (
      <>
        {days > 0 ? days + " d " : ""}
        {hours > 0 ? (hours < 10 ? "0" + hours : hours) + " h " : ""}
        {minutes > 0 ? (minutes < 10 ? "0" + minutes : minutes) + " min " : ""}
        {(seconds < 10 ? "0" + seconds : seconds) + " sec "}
      </>
    );
  }, [seconds]);

  return (
    <div className="timer" style={{ minHeight: "20px" }}>
      {seconds != null && (
        <>
          <ProgressBar height={height} time={progressTime} />
          <div className="timer__label" style={{ lineHeight: height + "px" }}>
            {getText()}
          </div>
        </>
      )}
    </div>
  );
};

export default Timer;
